<template>
  <FormElement
    type="text"
    :color="color"
    :size="size"
    :group="group"
    :field="field"
    v-model="currentValue"
    :validity="validity"
    :rule="rule"
    :trigger="trigger"
    :customRule="customRule"
    :delay="delay"
    :readonly="readonly"
    :disabled="disabled"
    :tips="tips"
    :gktext-color="color"
    :gktext-size="type == 'textarea' ? null : size"
    :gkareatext-size="type == 'textarea' ? size : null"
    :gk-text="type == 'text'"
    :gk-textarea="type == 'textarea'"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <template slot="pre"><slot name="pre" /></template>

    <template slot="validity">
      <component
        :is="com"
        v-bind="params"
        :name="field"
        :class="inputClass"
        :placeholder="placeholder"
        :maxlength="length"
      />
    </template>

    <template slot="tips" v-if="tips || $slots.tips">
      <slot name="tips" :tips="tips">{{tips}}</slot>
    </template>
    
    <template slot="error" slot-scope="{message}">
      <slot name="error" :message="message">{{message}}</slot>
    </template>

    <template slot="end">
      <slot name="end" />
    </template>
  </FormElement>
</template>

<script>
import formProps from './form.props'
import validityProps from './validity.props'
import VueTypes from 'vue-types'

import FormElement from './FormElement'

const prefixCls = 'gkui-form'

export default {
  name: 'gkui-form-text',
  components: {
    FormElement
  },
  props: Object.assign({
    type: VueTypes.oneOf(['text', 'password', 'textarea']).def('text')
  }, formProps, validityProps),
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    com () {
      if (this.type === 'textarea') {
        return 'textarea'
      }

      return 'input'
    },
    params () {
      if (this.type === 'textarea') {
        return {}
      }

      return {
        type: this.type
      }
    },
    prefixCls () {
      return prefixCls
    },
    inputClass () {
      if (this.type === 'textarea') {
        return `${prefixCls}-textarea`
      }

      return `${prefixCls}-text`
    }
  },
  watch: {
    value (value) {
      this.currentValue = value
    }
  }
}
</script>
